"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludedSubdivisionsCategoryKeywords = void 0;
exports.excludedSubdivisionsCategoryKeywords = [
    'city',
    'municipality',
    'region',
    'territory',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsLmNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3VudHJpZXMvY29uZmlndXJhdGlvbnMvZ2xvYmFsLmNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLG9DQUFvQyxHQUEwQztJQUN2RixNQUFNO0lBQ04sY0FBYztJQUNkLFFBQVE7SUFDUixXQUFXO0NBQ2QsQ0FBQSJ9